module.exports = __webpack_public_path__ + "media/images/story/top/step2_image-a06637c5b733b3097b4d2f80932f1828.png";